import { useParams } from '@tanstack/react-router';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { IntegrationSettingsUpdateLayout } from '../common';

export const DocusignIntegrationUpdateForm = () => {
    const { id } = useParams({ from: '/_authenticated/$currentEnterpriseId/EnterpriseIntegration/$id/Update' });

    const { mutateAsync } = useRepositoryMutation('docuSignContractingIntegration', 'delete');
    const handleDelete = async () => {
        await mutateAsync({ id });
    };

    return (
        <IntegrationSettingsUpdateLayout entityName="Docusign Integration" deleteAction={handleDelete}>
            <div>Update Form</div>
        </IntegrationSettingsUpdateLayout>
    );
};
